/**
 * Simple modal.
 */
export default function (modalName, clearParameters = false) {
    return {
        name: modalName,
        params: {},
        visible: false,
        clearParameters: clearParameters,
        hide: function () {
            this.visible = false;
        },
        show: function () {
            this.visible = true;
        },
        toggle: function () {
            this.visible = !this.visible;
        },
        isVisible: function () {
            return this.visible == true;
        },
        mounted: function () {
            const self = this;

            this.$watch('visible', (value) => {
                if (!value) {
                    if (this.clearParameters) {
                        this.params = {};
                    }
                }
            });

            document.addEventListener('keydown', function (event) {
                if (!self.visible) {
                    return;
                }

                event = event || window.event;

                if (event.key === 'Escape' || event.key === 'Esc') {
                    self.hide();
                }
            });

            window.livewire.on(this.name + '@show', function (params) {
                self.params = params || {};
                self.show();
            });

            window.livewire.on(this.name + '@hide', function (event) {
                self.hide(event);
            });
        },
    };
}
